import React from "react";

import { Box, Typography } from "@mui/material";
import { makeStyles } from "tss-react/mui";

import { MealKind } from "@/gql/graphql";
import { humanize } from "@/utils/string";

import MealRatingIcon from "../../../ClientDiary/Meals/components/MealRatingIcon";
import MealTypeIcon from "../../../ClientDiary/Meals/components/MealTypeIcon";
import { RatingReport } from "../utils/types";

const useStyles = makeStyles()(() => ({
  container: {
    border: "2px dotted #EDF0F5",
    padding: 16,
  },
  title: {
    color: "#363E45",
    fontFamily: "Mulish",
    fontWeight: 700,
    fontSize: 16,
  },
  mealTypeAndRatingContainer: {
    display: "flex",
    flexDirection: "row",
  },
  mealTypeContainer: {
    backgroundColor: "#F5F7FA",
    padding: "16px 24px",
    borderRadius: 4,
    flex: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  mealRatingContainer: {
    display: "flex",
    flex: 1,
    flexDirection: "column",
    alignItems: "center",
  },
  mealRatingIcon: {
    height: 24,
    width: 24,
  },
  ratings: {
    // Had to make specific width so the layout of ratings won't change
    width: "140px",
    display: "flex",
    justifyContent: "center",
    flexWrap: "wrap",
    height: "100%",
    rowGap: 8,
  },
  totalRating: {
    fontFamily: "Mulish",
    fontSize: 16,
    fontWeight: 700,
  },
  clientRatings: {
    color: "#7D8797",
    fontFamily: "Mulish",
    fontSize: 10,
    fontWeight: 700,
  },
}));

interface MealRatingReportItemProps {
  item: Record<string, RatingReport[]>;
}

const MealRatingReportItem: React.FC<MealRatingReportItemProps> = ({
  item,
}) => {
  const { classes } = useStyles();

  const type = Object.keys(item)[0];
  const ratings = Object.values(item)[0];

  return (
    <Box className={classes.container}>
      <Typography className={classes.title}>
        {humanize(type).toUpperCase()}
      </Typography>
      <Box height={16} />
      <Box className={classes.mealTypeAndRatingContainer}>
        <Box className={classes.mealTypeContainer}>
          <MealTypeIcon type={type as MealKind} size="extraLarge" />
        </Box>
        <Box width={16} />
        <Box className={classes.mealRatingContainer}>
          <Box className={classes.ratings}>
            {ratings.map((i) => {
              const isLastItem = ratings.length - 1 === i;

              return (
                <Box
                  key={i.rating}
                  display="flex"
                  paddingRight={!isLastItem ? "8px" : undefined}
                >
                  <Typography className={classes.totalRating}>
                    {i.totalRating}
                  </Typography>
                  <Box width={4} />
                  <MealRatingIcon
                    className={classes.mealRatingIcon}
                    rating={i.rating}
                  />
                </Box>
              );
            })}
          </Box>
          <Typography className={classes.clientRatings}>
            Client Ratings
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default MealRatingReportItem;
